/* eslint-disable */
import React from "react";
import { Card, Title, Text, Divider } from "@mantine/core";

export default function HeaderCard() {
  return (
    <Card shadow="sm" radius="md" withBorder>
      <Title order={2} align="center" mb="sm">
        Privacy Policy for ACN Connect
      </Title>
      <Text align="center" size="sm" color="dimmed">
        Last Updated: 12/11/2025
      </Text>
      <Divider my="md" />
      <Text>
        {" "}
        <strong>Ahtahkakoop Cree Nation Connect (ACN Connect)</strong>, the
        mobile and web application developed and published by{" "}
        <strong>Quantum Strategies Inc.</strong>, available on the{" "}
        <strong>Google Play Store</strong>, <strong>Apple App Store</strong> and
        the <strong>official website.</strong>
      </Text>
      <Text mt="sm">
        This Privacy Policy describes our policies and procedures on the
        collection, use, and disclosure of your information when you use our
        services. It also informs you about your privacy rights and how
        applicable laws protect you.
      </Text>
      <Text mt="sm">
        By using any version of the ACN Connect application (Android, iOS, or
        Web), you agree to the collection and use of information in accordance
        with this Privacy Policy.
      </Text>
    </Card>
  );
}
